export default __webpack_public_path__ + "static/media/(26).7970c711.jpg";